module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img_center"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hrightt"
  }, [_c('span', {
    staticClass: "navy"
  }, [_vm._v("The colorful undulations of this crocheted baby blanket are reminiscent of schools of small fish swimming in the ocean. The stitch pattern works up extremely quickly, and the vivid stripes keep you eager to see more. Bright colors are perfect for a modern baby’s room, and are likely to be loved long into childhood (and maybe into adulthood, too).")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("30\" wide x 36\" long")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Yarn")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Berroco Comfort (50% super fine nylon / 50% super fine acrylic; 100 grams / 210 yards): 1 skein each #9761 Lovage (A), #9724 Pumpkin (B), #9717 Raspberry Coulis (C), #9740 Seedling (D), #9725 Dutch Teal (E), and #9730 Teaberry (F)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Crochet Hook")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Crochet hook size US G/6 (4 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Change hook size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("15 sts and 14 rows = 4\" (10 cm) in Fish Ripple Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "navy"
  }, [_vm._v("Stitch Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("FISH RIPPLE PATTERN")]), _vm._v(" (multiple of 16 sts + 2; 8-row repeat)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Note: Stitch Pattern is reversible; there is no RS or WS.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Set-Up Row:")]), _vm._v(" Sc in 2nd ch from hook, *sc in next ch, ch 1, skip 1 ch, hdc in next ch, ch 1, skip 1 ch, dc in next ch, [ch 1, skip 1 ch, tr in next ch] twice, ch 1, skip 1 ch, dc in next ch, ch 1, skip 1 ch, hdc in next ch, ch 1, skip 1 ch, sc in next ch, ** ch 1, skip 1 ch; repeat from *, ending last repeat at **, sc in last ch, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rows 1 and 5:")]), _vm._v(" Ch 1, sc in each st and ch-1 sp, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rows 2 and 6:")]), _vm._v(" Ch 1, sc in each sc across, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rows 3 and 4:")]), _vm._v(" Ch 4 (counts as tr), skip first st, *tr in next st, ch 1, skip 1 st, dc in next st, ch 1, skip 1 st, hdc in next st, [ch 1, skip 1 ch, sc in next st] twice, ch 1, skip 1 st, hdc in next st, ch 1, skip 1 st, dc in next st, ch 1, skip 1 st, tr in next st, **, ch 1, skip 1 st; repeat from *, ending last repeat at **, 1 tr in last st, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rows 7 and 8:")]), _vm._v(" Ch 1, 1 sc in first st, *sc in next st, ch 1, skip 1 st, hdc in next st, ch 1, skip 1 st, dc in next st, [ch 1, skip 1 st, tr in next st] twice, ch 1, skip 1 st, dc in next st, ch 1, skip 1 st, hdc in next st, ch 1, skip 1 st, sc in next st **, ch 1, skip 1 st; repeat from *, ending last repeat at **, sc in last st, turn, ch 1.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Repeat Rows 1-8 for Fish Ripple Pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('b', [_vm._v("STRIPE SEQUENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Work 2 rows each in *B, C, D, E, F, then A; repeat from * for Stripe Sequence")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "navy"
  }, [_vm._v("Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Using A, ch 114. Begin Fish Ripple Pattern; work Set-Up Row. Continuing in Fish Ripple Pattern, begin Stripe Sequence; work even until piece measures approximately 36\" from the beginning, ending with Row 7 of Fish Ripple Pattern. Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "navy"
  }, [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Edging:")]), _vm._v(" Using A, work 1 row sc evenly along both side edges of blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Block lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "img_center"
  }, [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_003.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }, [_c('p', {
    staticClass: "hright"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Named for the Moroccan city of Marrakesh, this coverlet reflects the city’s exotic flavors and rich tones. The solid background is made using crocheted afghan stitch, which requires a particular long hook, and is then embellished with lanky folk art flowers. The monochromatic floral embroidery is a loose interpretation of the gold embroidery found on traditional caftans from the region.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("45\" wide x 60\" long")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Yarn")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Berroco Comfort (50% super fine nylon / 50% super fine acrylic; 100 grams / 210 yards): 15 skeins #9724 Pumpkin (A) Berroco Comfort Chunky (50% super fine nylon / 50% super fine acrylic; 100 grams / 150 yards): 2 skeins #5703 Barley (B)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Crochet Hook")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Tunisian crochet hook size US H/8 (5 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Change hook size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("18 sts and 32 rows = 4\" (10 cm) in Tunisian Stitch, using A")])]), _vm._v(" "), _c('p', {
    staticClass: "img_center"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_004.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Stitch Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("TUNISIAN STITCH")]), _vm._v(" (any number of sts; 2-row repeat)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Note: All rows are RS rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Set-Up Row:")]), _vm._v(" Insert hook in 2nd ch from the hook, yo and pull through, keeping the loop on the hook; repeat in each ch across. Do not turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Working from left to right, ch 1, *yo and pull through the first 2 loops on the hook; repeat from * to end. Do not turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" Insert hook under the second single vertical thread, from right to left, yo and pull through, keeping the loop on the hook; repeat in each vertical thread to end. Do not turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Repeat Rows 1 and 2 for Tunisian Stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Afghan")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("PANEL")]), _vm._v(" (make 3)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Using A, ch 65. Begin Tunisian st; work even until piece measures 60\" from the beginning. Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Edging:")]), _vm._v(" Using A, work 1 row of sc across each side edge of each Panel. Join 3 Panels together as follows: Attach A to corner of first Panel, ch 2, sl st in corner of 2nd Panel, *ch 2, sk 1-2 edge sts, sl st in first Panel, ch 2, sk 1-2 edge sts, sl st in 2nd Panel, keeping Panels even; repeat from * to end. Join 2nd and 3rd Panels in same manner.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Embroidery:")]), _vm._v(" Using B, work embroidery following Diagrams.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Block lightly.")])]), _c('p', {
    staticClass: "img_center"
  }, [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_005.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }, [_c('p', {
    staticClass: "hrightt"
  }, [_c('span', {
    staticClass: "pink1"
  }, [_vm._v("Though this afghan is worked in just one neutral color, the textures make it visually thrilling. The highly dimensional ruffles are reminiscent of forms found in nature, from coral reefs to kale and lettuce leaves to the S-shaped curves of snakes. To accomplish this effect, flat panels of double crochet are punctuated with more ornate strips of treble crochet that coil around a mesh stitch base.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("45\" wide x 60\" long")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Yarn")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Berroco Comfort (50% super fine nylon / 50% super fine acrylic; 100 grams / 210 yards): 21 skeins #9703 Barley")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Crochet Hook")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Crochet hook size US F/5 (3.75 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Change hook size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "violet"
  }, [_vm._v("18 sts and 10 rows = 4\" (10 cm) in Double Crochet (dc)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "pink1"
  }, [_vm._v("Afghan")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("WIDE STRIP")]), _vm._v(" (make 2)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Ch 57.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Set-Up Row:")]), _vm._v(" Dc in 4th ch from hook and in each ch across– 55 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("All Rows:")]), _vm._v(" Ch 3 (counts as dc), skip first dc, dc in each dc across, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Work even until piece measures 60\" from the beginning. Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('b', [_vm._v("NARROW STRIP")]), _vm._v(" (make 2)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Ch 30.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Set-Up Row:")]), _vm._v(" Dc in 4th ch from hook and in each ch across–27 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("All Rows:")]), _vm._v(" Ch 3 (counts as dc), skip first dc, dc in each dc across, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Work even until piece measures 60\". Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('b', [_vm._v("RUFFLED STRIP")]), _vm._v(" (make 3)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Ch 273.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Dc in 6th ch from hook (counts as dc, ch 2, dc), *ch 2, skip 2 ch, dc in next ch; repeat from * to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" Ch 5 (counts as dc and ch 2), skip 1st dc, dc in next dc, *ch 2, skip 1 dc, dc in next dc; repeat from * to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 3:")]), _vm._v(" Repeat Row 2.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 4:")]), _vm._v(" Ch 4 (counts as tr), work 4 tr over first ch-2 sp, *turn work slightly to the left and work 5 tr over post of next dc, turn work slightly to the left and work 5 tr in ch-2 sp of row below, turn work slightly to the right and work 5 tr over post of next dc, turn work slightly to the right and work 5 tr in next ch-2 sp; repeat from * to end. Turn and work Row 4 along Row 2, then along Row 1. Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink1"
  }, [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Sew Strips together in the following order: Narrow, Ruffled, Wide, Ruffled, Wide, Ruffled, Narrow.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Block lightly.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b14e5798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/4_Chapter.vue
// module id = 66
// module chunks = 0